import { TableHead, TableRow, TableHeaderText, TableHeadCell, Box, Checkbox } from '@pocketlaw/tetris';
import { useTableContext } from './TableContext';
import { ACTION_CELL_WIDTH, TITLE_CELL_WIDTH } from './constants';
import { useSearchContext } from '../SearchProvider';
export function SearchResultsTableHead() {
    const { values } = useSearchContext();
    const { columns } = values;
    const { results, selected, setSelected, actions } = useTableContext();
    const pageSelectedEntries = results.filter((result) => selected.map((item) => item.entityId).includes(result.entityId));
    const pageUnselectedEntries = results.filter((result) => !selected.map((item) => item.entityId).includes(result.entityId));
    const pageSelected = pageSelectedEntries.length === results.length;
    const indeterminate = pageSelectedEntries.length > 0 && pageSelectedEntries.length < results.length;
    const handleToggleSelectAll = () => {
        if (pageSelected) {
            setSelected({ type: 'toggle', payload: pageSelectedEntries });
        }
        else {
            setSelected({ type: 'toggle', payload: pageUnselectedEntries });
        }
    };
    const getSortId = (column) => {
        if (column.sortable) {
            return column.id;
        }
        return undefined;
    };
    const getStickyColumn = (column) => {
        if (column.id === 'action') {
            return 'right';
        }
        return undefined;
    };
    const visibleColumns = columns.filter((col) => col.active);
    const getCellWidth = (id) => {
        if (id === 'name') {
            return TITLE_CELL_WIDTH;
        }
        if (id === 'action') {
            return ACTION_CELL_WIDTH;
        }
        return undefined;
    };
    return (<TableHead>
      <TableRow>
        {visibleColumns.map((column) => (<TableHeadCell key={column.id} id={column.id} maxWidth={getCellWidth(column.id)} colSpan={column.colSpan} stickyColumn={getStickyColumn(column)}>
            <Box alignItems="center" gap="md">
              {column.id === 'name' && actions && (<Box px="sm">
                  <Checkbox onChange={handleToggleSelectAll} checked={pageSelected} indeterminate={indeterminate}/>
                </Box>)}
              {column.id !== 'action' && <TableHeaderText sortId={getSortId(column)}>{column.label}</TableHeaderText>}
            </Box>
          </TableHeadCell>))}
      </TableRow>
    </TableHead>);
}
